import { styled } from 'opensolar-ui'
import { memo } from 'react'
import { useTranslate } from 'react-admin'
import { OpenSolarThemeType } from 'Themes'
import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'

const useStyles = makeOpenSolarStyles((theme: OpenSolarThemeType) => ({
  container: {
    fontSize: theme.typography.subtitle2.fontSize,
  },
}))

const ColoredSpan = styled('span', { name: 'ColoredSpan' })(({ theme }) => ({
  color: theme.palette.grey[810],
}))

type ProjectNamePropsType = {
  business_name?: string
  address?: string
  id?: number
}

const ProjectName = memo(({ business_name, address, id }: ProjectNamePropsType) => {
  const translate = useTranslate()
  const classes = useStyles()

  const addressResolved = address || (id ? `${translate('Project')}: ${id}` : translate('(Address not specified)'))

  return (
    <div title="project-list-address-name" className={classes.container}>
      {addressResolved}
      <br /> <ColoredSpan>{business_name != null && business_name}</ColoredSpan>
    </div>
  )
})

export default ProjectName
